export const SETCONTRACTLIST = "SETCONTRACTLIST";